// extracted by mini-css-extract-plugin
module.exports = {"message":"containers-ManagerDashboard-ManagerDashboard__message--CmWVI","report":"containers-ManagerDashboard-ManagerDashboard__report--QbEcY"};